module.exports = __webpack_public_path__ + "static/media/icon_copy.74f33365.svg";